import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import { InfoBox } from "react-google-maps/lib/components/addons/InfoBox"
// const { compose, withProps, withStateHandlers } = require("recompose");
import { compose, withProps, withStateHandlers } from "../../node_modules/recompose"
// import compose from "recompose/compose"
// import withProps from "recompose/withProps"
// import withStateHandlers from "recompose/withStateHandlers"

const mapStyle = require('./mapStyleLight.json')
// const mapStyle = require('./mapStyleDark.json')

// const ReactGoogleMap = withScriptjs(withGoogleMap((props) =>
//   <GoogleMap
//     defaultZoom={16}
//     defaultCenter={{ lat: 47.2059287, lng: 20.7528 }}
//     defaultOptions={{
//       disableDefaultUI : true,
//       styles: mapStyle
//       }
//     }
//   >
//     {props.isMarkerShown && 
//     // <Marker position={{ lat: 47.2059286, lng: 20.7528 }} />
//     <Marker
//       position={{ lat: 47.2059286, lng: 20.7528 }}
//       onClick={props.onToggleOpen}
//     >
//       {props.isOpen && <InfoBox
//         onCloseClick={props.onToggleOpen}
//         options={{ closeBoxURL: ``, enableEventPropagation: true }}
//       >
//         <div style={{ backgroundColor: `yellow`, opacity: 0.75, padding: `12px` }}>
//           <div style={{ fontSize: `16px`, fontColor: `#08233B` }}>
//             Hello, Kaohsiung!
//           </div>
//         </div>
//       </InfoBox>}
//     </Marker>
//     }
//   </GoogleMap>
// ))

const ReactGoogleMap = compose(
  withProps({
    googleMapURL:"https://maps.googleapis.com/maps/api/js?key=AIzaSyCQ-3PVMhgG49ewjsW-0n5AOjQSRbkfVJE&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div id="google-map" />,
    mapElement: <div style={{ height: `100%` }} />,
    center: { lat: 47.2059287, lng: 20.7528 },
  }),
  withStateHandlers(() => ({
    isOpen: false,
  }), {
    onToggleOpen: ({ isOpen }) => () => ({
      isOpen: !isOpen,
    })
  }),
  withScriptjs,
  withGoogleMap
)(props =>
  <GoogleMap
    defaultZoom={16}
    defaultCenter={props.center}
    defaultOptions={{ 
      disableDefaultUI : true,
      styles: mapStyle
    }}
  >
    <Marker
      position={{ lat: 47.2059287, lng: 20.7528 }}
      onClick={props.onToggleOpen}
    >
      {props.isOpen && <InfoBox
        onCloseClick={props.onToggleOpen}
        options={{ closeBoxURL: ``, enableEventPropagation: true }}
      >
        <div id="google-map-label">
          <h1>Kisújszállási Városgazdálkodási <br/>Nonprofit Kft.</h1>
          <address>
            5310 Kisújszállás
            <br/>
            Kossuth Lajos U. 74.
          </address>
        </div>
      </InfoBox>}
    </Marker>
  </GoogleMap>
);

export default ReactGoogleMap;